import React from 'react'
import PropTypes from 'prop-types'
import {customIcon} from '../shared/styles'

const ApplicationIcon = ({size}) => {
    const {container, content} = customIcon(size, '#5bda9a')
    return (
        <div style={container}>
            <i data-testid="mi" className="material-icons" style={content}>
                list
            </i>
        </div>
    )
}
ApplicationIcon.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large', 'x-large']).isRequired
}
export default ApplicationIcon
